import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getFile } from '../../lib/file'

const Avatar = ({ avatar_url, id, layout, role, entityType, className = '', style = {} }) => {
	const [avatar, setAvatar] = useState(null)

	const fetchAvatar = async () => {
		if (avatar_url) {
			try {
				const avt = await getFile(avatar_url)
				setAvatar(avt.publicUrl)
			} catch (error) {
				console.error('Error fetching avatar:', error)
			}
		}
	}

	useEffect(() => {
		fetchAvatar()
	}, [avatar_url])

	const defaultStyle = {
		width: '40px',
		height: '40px',
		objectFit: 'cover',
		cursor: 'pointer',
		...style
	}

	const defaultClassName = `rounded-circle ${className}`

	return (
		<Link to={`${process.env.PUBLIC_URL}/${role}/${entityType}/detail/${id}/${layout}`} className="text-decoration-none">
			<img src={avatar || '/assets/images/user/user-dp.png'} alt={`${entityType} Avatar`} className={defaultClassName} style={defaultStyle} />
		</Link>
	)
}

export { Avatar }
